// TODO refactor
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Card from '../UI/Card/Card';
import LoadingSpinner from '../UI/LoadingSpinner/LoadingSpinner';
import Input from '../UI/Input/Input';
import Button from '../UI/Button/Button';
import ErrorModal from '../UI/ErrorModal/ErrorModal';
import { VALIDATOR_MINLENGTH, VALIDATOR_CAPITAL, VALIDATOR_DIGIT, VALIDATOR_SYMBOL } from '../../utils/validators';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import './ResetPassword.css';
import Athenalogo from '../../assets/images/Athena_logo_final.png';
import { SupportInfo } from '../SupportInfo/SupportInfo';

const Auth = () => {
  const { token } = useParams();
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [isRegistration, setIsRegistration] = useState(true);
  const [isPasswordReset, setIsPasswordReset] = useState(true);
  const [count, setCount] = useState(0);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler, setFormData] = useForm(
    {
      email: {
        value: '',
        isValid: false
      },
      password: {
        value: '',
        isValid: false
      }
    },
    false
  );

  const buttonClickHandler = () => {
    setCount(count + 1);
  };

  const switchModeHandler = () => {
    if (!isLoginMode) {
      setFormData(formState.inputs.email.isValid && formState.inputs.password.isValid);
    } else {
      setFormData(
        {
          ...formState.inputs
        },
        false
      );
    }
    setIsLoginMode((prevMode) => !prevMode);
    setIsRegistration(!isRegistration);
    if (isRegistration && isPasswordReset && count === 1) {
      setCount(0);
      setIsPasswordReset(!isPasswordReset);
    }
  };

  const authSubmitHandler = async (event) => {
    event.preventDefault();

    if (isPasswordReset && count === 1) {
      try {
        await sendRequest(
          import.meta.env.VITE_BACKEND_URL + `/api/users/resetPassword/${token}`,
          'POST',
          JSON.stringify({
            password: formState.inputs.password.value
          }),
          {
            'Content-Type': 'application/json'
          }
        );
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleChange = (a) => {
    let class_capital;
    let class_len;
    let class_number;
    let class_symbol;
    if (a.length >= 8) {
      class_len = 'check';
    }
    if (/[0-9]/.test(a) === true) {
      class_number = 'check';
    }
    if (/[A-Z]/.test(a) === true) {
      class_capital = 'check';
    }
    // eslint-disable-next-line no-useless-escape
    if (/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.@#\\/]/.test(a) === true) {
      class_symbol = 'check';
    }
    return [class_len, class_capital, class_number, class_symbol];
  };

  const disabledCheck = () => {
    let disabled;
    let mess;
    let style = {};
    if (count === 0) {
      disabled = !formState.inputs.password.isValid;
      mess = isLoginMode ? 'Reset Password' : 'Next';
    }
    if (count === 1 || (isPasswordReset && count === 1)) {
      style = { display: 'none' };
    }
    return [disabled, mess, style];
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center" style={{ clear: 'both' }}>
          <LoadingSpinner />
        </div>
      )}
      {!isLoading && (
        <div className="container">
          <Card className="authentication">
            <img src={Athenalogo} alt="logo" />
            <p className="headline">{count === 0 ? 'Password reset' : 'Successful password reset'}</p>
            <form onSubmit={authSubmitHandler}>
              {/*---------------Registration---------------*/}
              {count === 0 && isPasswordReset && (
                <div>
                  <div className="info">
                    <p>Set a new password. Make sure it contains:</p>
                    <ul className={handleChange(formState.inputs.password.value)[0]}>
                      <li>8 or more characters</li>
                    </ul>
                    <ul className={handleChange(formState.inputs.password.value)[1]}>
                      <li>1 capital letter</li>
                    </ul>
                    <ul className={handleChange(formState.inputs.password.value)[2]}>
                      <li>1 digit</li>
                    </ul>
                    <ul className={handleChange(formState.inputs.password.value)[3]}>
                      <li>1 symbol</li>
                    </ul>
                  </div>
                </div>
              )}
              {count === 0 && isPasswordReset && (
                <div>
                  <Input
                    element="input"
                    id="password"
                    type="password"
                    placeholder="Password"
                    validators={[VALIDATOR_MINLENGTH(8), VALIDATOR_CAPITAL(), VALIDATOR_DIGIT(), VALIDATOR_SYMBOL()]}
                    onInput={inputHandler}
                  />
                </div>
              )}
              {count === 1 && isPasswordReset && (
                <div className="submit">
                  <div>
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="check">
                        <path
                          id="check_2"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M40 7C21.784 7 7 21.784 7 40C7 58.216 21.784 73 40 73C58.216 73 73 58.216 73 40C73 21.784 58.216 7 40 7ZM40.0003 70C23.4628 70 10.0003 56.5375 10.0003 40C10.0003 23.4625 23.4628 10 40.0003 10C56.5378 10 70.0003 23.4625 70.0003 40C70.0003 56.5375 56.5378 70 40.0003 70ZM34.0278 56L34.0309 55.9967L35.1399 57.1953L59.1892 31.2021L57.1518 29L35.1368 52.7945L24.0374 40.7979L22 43L34.0278 56Z"
                          fill="#4DCB82"
                        />
                      </g>
                    </svg>
                  </div>
                  <div>
                    <p className="text">You can now use your new password to log into your account</p>
                  </div>
                  <a href="/auth">
                    <Button onClick={switchModeHandler}>{'LOG IN'}</Button>
                  </a>
                </div>
              )}
              {/*---------------//Registration---------------*/}

              <div className="button-submit" style={disabledCheck()[2]}>
                <Button type="submit" disabled={disabledCheck()[0]} onClick={buttonClickHandler}>
                  {disabledCheck()[1]}
                </Button>
              </div>
            </form>
          </Card>
          <SupportInfo />
        </div>
      )}
    </React.Fragment>
  );
};

export default Auth;
